export default __webpack_public_path__ + "static/fax-colors-ff7e718bb4b45b88721404e8a3718b52.png";